export default __webpack_public_path__ + "static/media/bg_3.224948b1.png";